import React from 'react';
import { motion } from 'framer-motion';
import Button from './ui/Button';

const Hero = () => {
  return (
    <div className="relative h-screen">
      <div className="absolute inset-0">
        <img 
          src={'/static/images/heroImg.jpg'}
          alt="Spa treatment"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black opacity-40"></div>
      </div>
      
      <div className="relative z-10 flex flex-col items-start md:items-center justify-center h-full text-center text-white px-4">
        <motion.h1 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="text-3xl md:text-5xl text-left md:text-center font-semibold mb-6 text-primary font-heading"
        >
          <span className='block md:inline text-accent-light font-heading text-5xl md:text-6xl italic'>
            Awaken
          </span> Your Best Self <br />with Every Touch
        </motion.h1>
        
        <motion.p 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut", delay: 0.3 }}
          className="text-sm/6 text-left md:text-center md:text-md max-w-2xl mb-8 font-body md:px-8"
        >
          At Piel Perfecta, we believe every touch has the power to rejuvenate, restore, and elevate your well-being. 
          Experience tailored treatments designed to leave you feeling refreshed, balanced, and truly renewed. 
          Step into a sanctuary where your best self awaits.
        </motion.p>
        
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut", delay: 0.6 }}
        >
          <Button 
            to="/booking"
            className="
              bg-accent-hard font-semibold text-secondary px-6 py-2 md:px-8 md:py-3 rounded-md text-sm md:text-lg hover:bg-accent-light 
              hover:text-primary-dark transition-colors
            "
          >
            BOOK AN APPOINTMENT
          </Button>
        </motion.div>
      </div>
    </div>
  );
};

export default Hero;
